import { ThemeEvents } from '@theme/events';
import { formatMoney } from '@theme/money-formatting';

/**
 * Keeps an add-to-cart button's price label in sync with the quantity
 * selector, showing quantity x unit price instead of a fixed unit price.
 */
class AddToCartLivePrice extends HTMLElement {
  #abortController = new AbortController();

  connectedCallback() {
    const { signal } = this.#abortController;
    document.addEventListener(ThemeEvents.quantitySelectorUpdate, this.#handleQuantityUpdate, { signal });
    this.#update();
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  /** @param {CustomEvent<{quantity: number}>} event */
  #handleQuantityUpdate = (event) => {
    const form = this.closest('product-form-component');
    if (!form || !(event.target instanceof Node) || !form.contains(event.target)) return;

    this.#update(event.detail?.quantity);
  };

  /** @param {number} [quantity] */
  #update(quantity) {
    const unitPrice = parseInt(this.dataset.unitPrice || '', 10);
    const format = this.dataset.moneyFormat;
    const currency = this.dataset.currency;
    const baseText = this.dataset.baseText;
    const label = this.querySelector('.add-to-cart-button__label');

    if (!label || !format || !currency || !baseText || isNaN(unitPrice)) return;

    let qty = quantity;
    if (!qty) {
      const input = this.closest('product-form-component')?.querySelector('input[name="quantity"]');
      qty = parseInt(input?.value || '', 10) || 1;
    }

    const formattedPrice = formatMoney(unitPrice * qty, format, currency);
    label.textContent = `${baseText} — ${formattedPrice}`;
  }
}

if (!customElements.get('add-to-cart-live-price')) {
  customElements.define('add-to-cart-live-price', AddToCartLivePrice);
}
